import { render, staticRenderFns } from "./ModuleReworksListPerStudent.vue?vue&type=template&id=eaca2c88"
import script from "./ModuleReworksListPerStudent.vue?vue&type=script&lang=js"
export * from "./ModuleReworksListPerStudent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports